var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 148,
    height: 148,
    viewBox: "0 0 148 148",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M115.049 47.0361V123.722C115.049 128.259 111.417 131.937 106.936 131.937H40.6757C36.1948 131.937 32.5623 128.259 32.5623 123.722V34.7162C32.5623 30.1787 36.1948 26.5003 40.6757 26.5003H93.8808",
    fill: "url(#paint0_linear_894_46042)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M115.049 47.0361L101.994 47.0361C97.5134 47.0361 93.8809 43.3577 93.8809 38.8202L93.8809 26.5003",
    fill: "#A7C6E4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2938 56.2829L56.7163 56.6173C59.2545 56.6419 61.6632 57.7557 63.3438 59.6819L67.3386 64.2601C68.3654 65.4367 69.8414 66.1106 71.392 66.1106H125.318C130.266 66.1106 134.277 70.1721 134.277 75.1823V137.928C134.277 142.938 130.266 147 125.318 147H22.2938C17.3461 147 13.3352 142.938 13.3352 137.928V65.3546C13.3352 60.3445 17.3461 56.2829 22.2938 56.2829Z",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3352 66.1785V65.3557C13.3352 60.3449 17.3461 56.2829 22.2938 56.2829L56.7163 56.6173C59.2545 56.642 61.6632 57.7559 63.3438 59.6822L67.3386 64.261C68.3654 65.4378 69.8414 66.1117 71.392 66.1117",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3352 66.1785V65.3557C13.3352 60.3449 17.3461 56.2829 22.2938 56.2829L56.7163 56.6173C59.2545 56.642 61.6632 57.7559 63.3438 59.6822L67.3386 64.261C68.3654 65.4378 69.8414 66.1117 71.392 66.1117",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M76.3655 66.1265H13.4861",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M48.0692 98.4318L52.499 95.3338L53.6241 97.3987L48.6668 99.5712L53.6591 101.742L52.499 103.843L48.0692 100.746L48.5611 106.229H46.2759L46.6978 100.746L42.303 103.879L41.1079 101.707L46.0653 99.5351L41.1079 97.4341L42.268 95.3338L46.7335 98.4318L46.2759 92.9479H48.5968L48.0692 98.4318Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M65.684 98.4318L70.1137 95.3338L71.2389 97.3987L66.2815 99.5712L71.2739 101.742L70.1137 103.843L65.684 100.746L66.1759 106.229H63.8906L64.3126 100.746L59.9178 103.879L58.7227 101.707L63.68 99.5351L58.7227 97.4341L59.8828 95.3338L64.3482 98.4318L63.8906 92.9479H66.2115L65.684 98.4318Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M83.298 98.4318L87.7278 95.3338L88.8529 97.3987L83.8955 99.5712L88.8879 101.742L87.7278 103.843L83.298 100.746L83.7899 106.229H81.5047L81.9266 100.746L77.5318 103.879L76.3367 101.707L81.294 99.5351L76.3367 97.4341L77.4968 95.3338L81.9622 98.4318L81.5047 92.9479H83.8255L83.298 98.4318Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M100.913 98.4318L105.343 95.3338L106.468 97.3987L101.511 99.5712L106.503 101.742L105.343 103.843L100.913 100.746L101.405 106.229H99.1199L99.5418 100.746L95.147 103.879L93.9519 101.707L98.9093 99.5351L93.9519 97.4341L95.112 95.3338L99.5775 98.4318L99.1199 92.9479H101.441L100.913 98.4318Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M122.469 56.8174C123.412 56.8174 124.177 56.0428 124.177 55.0874C124.177 54.1319 123.412 53.3574 122.469 53.3574C121.526 53.3574 120.761 54.1319 120.761 55.0874C120.761 56.0428 121.526 56.8174 122.469 56.8174Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M47.4366 18.6276C49.117 18.6276 50.4791 17.2481 50.4791 15.5463C50.4791 13.8446 49.117 12.465 47.4366 12.465C45.7562 12.465 44.394 13.8446 44.394 15.5463C44.394 17.2481 45.7562 18.6276 47.4366 18.6276Z",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M136.009 35.9182L134.319 34.2064L132.629 35.9182L134.319 37.6299L136.009 35.9182Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0971 44.1336L21.4067 42.4219L19.7163 44.1336L21.4067 45.8454L23.0971 44.1336Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M95.4416 16.0634L93.7512 14.3517L92.0608 16.0634L93.7512 17.7752L95.4416 16.0634Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4204 16.1288L20.1661 18.9423C19.8812 19.2979 19.8812 19.8071 20.1661 20.1627L22.4204 22.9762L19.6423 20.6932C19.2912 20.4046 18.7884 20.4046 18.4373 20.6932L15.6592 22.9762L17.9135 20.1627C18.1984 19.8071 18.1984 19.2979 17.9135 18.9423L15.6592 16.1288L18.4373 18.4118C18.7884 18.7004 19.2912 18.7004 19.6423 18.4118L22.4204 16.1288Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0798 19.5519L19.5132 20.0312L19.0399 29.7186L18.5666 20.0312L9 19.5519L18.5666 19.0727L19.0399 9.38531L19.5132 19.0727L29.0798 19.5519Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M112.7 27.4085L111.562 28.8295C111.418 29.0091 111.418 29.2663 111.562 29.4459L112.7 30.8669L111.297 29.7138C111.12 29.5681 110.866 29.5681 110.688 29.7138L109.285 30.8669L110.424 29.4459C110.568 29.2663 110.568 29.0091 110.424 28.8295L109.285 27.4085L110.688 28.5616C110.866 28.7073 111.12 28.7073 111.297 28.5616L112.7 27.4085Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M116.063 29.138L111.231 29.3801L110.992 34.2735L110.753 29.3801L105.921 29.138L110.753 28.8959L110.992 24.0025L111.231 28.8959L116.063 29.138Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M125.327 18.3632L121.895 14.8876L118.463 18.3632L121.895 21.8387L125.327 18.3632Z",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M121.895 1L122.455 15.4565H121.335L121.895 1Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M121.895 35.6431L122.455 21.1866H121.335L121.895 35.6431Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M139 18.321L124.725 17.7537V18.8884L139 18.321Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M104.791 18.321L119.065 17.7537V18.8884L104.791 18.321Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_894_46042",
    x1: 74.1083,
    y1: 20.2507,
    x2: 73.4861,
    y2: 138.523,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72ACD7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.163445,
    stopColor: "#70A9D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.302464,
    stopColor: "#6AA0C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.432625,
    stopColor: "#6192B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.557382,
    stopColor: "#547F9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.678308,
    stopColor: "#43657E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796299,
    stopColor: "#2E4657"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.909791,
    stopColor: "#162129"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.663a3b5e727eec38a0e601a15dd9d660.svg";
export { ForwardRef as ReactComponent };